import React from 'react'

import general from '@planningcenter/icons/sprites/general.svg'
import api from '@planningcenter/icons/sprites/api.svg'
import toolbar from '@planningcenter/icons/sprites/toolbar.svg'

const sprites: Record<string, string> = { general, api, toolbar }

interface ExternalIconProps extends React.SVGProps<SVGSVGElement> {
  symbol: string
  size?: number
  title?: string
  description?: string
}

export default function ExternalIcon({
  symbol: s,
  size,
  title,
  description,
  className,
  ...rest
}: ExternalIconProps) {
  const [collection, symbol] = s.replace('.svg', '').split('#')
  const href = `${sprites[collection]}#${symbol}`

  const ariaProps: Record<string, string | boolean> = {}
  const titleId = title ? `title-${symbol}` : undefined
  const descId = description ? `desc-${symbol}` : undefined

  if (title || description) {
    ariaProps['aria-labelledby'] = [titleId, descId].filter(Boolean).join(' ')
  } else {
    ariaProps['aria-hidden'] = true
  }

  const iconSize = size ? { width: size, height: size } : undefined

  return (
    <svg
      role="img"
      className={['symbol', className].filter(Boolean).join(' ')}
      fill="currentColor"
      style={iconSize}
      {...ariaProps}
      {...rest}
    >
      {title && <title id={titleId}>{title}</title>}
      {description && <desc id={descId}>{description}</desc>}
      <use href={href} />
    </svg>
  )
}
